<script lang="ts">
    import { blur } from 'svelte/transition';
    export let error: string;
    export let errorDetails: string = '';

</script>

<div class="item" class:error={error}>
    <slot />
    {#if error}
        <div in:blur={{duration: 500, delay: 0}} >
            <div class="error-info">{error}</div>
            <div class="error-info error-info-details">{errorDetails}</div>
        </div>
    {/if}
</div>

<style>
    .item {
        border-radius: 6px;
        width: 100%;
    }
    .error {
        margin: 2px 0;
        padding: 6px;
        background-color: #b94a4844;
    }
    .error-info {
        color: #b94a48;
        font-size: 13px;
        margin-top: 4px;
    }
    .error-info-details {
        font-size: 11px;
        margin-top: 2px;
        opacity: 0.7;
    }
</style>